{
  "nav": {
    "home": "Home",
    "services": "Services",
    "prices": "Prices",
    "projects": "Projects",
    "about": "About Khromatik",
    "contact": "Contact",
    "email": "Email",
    "linkedin": "LinkedIn"
  },
  "backToProjects": "Back to projects",
  "projectOverview": "Project overview",
  "overview": "Overview",
  "challenge": "The challenge",
  "businessNeed": "The business need",
  "philosophy": "The philosophy",
  "goal": "The goal",
  "solution": "The solution",
  "polestarLandingPage": "Polestar Live landing page",
  "footer": {
    "legal": "Legal notice"
  },
  "whatsapp": {
    "label": "Chat on WhatsApp",
    "prefill": "Hi, I'd like to discuss a video or branding project."
  },
  "cookies": {
    "title": "Cookies and privacy",
    "body": "We use optional analytics (Google Analytics and Microsoft Clarity) to understand how the site is used. You can accept or reject non-essential cookies. Essential storage keeps your language and this choice.",
    "learnMore": "Learn more",
    "accept": "Accept all",
    "reject": "Reject non-essential",
    "settings": "Cookie settings"
  }
}
